import epoqConfig from "./epoq-config";
import useDepartment from "@/composables/use-department";

const { departmentCapitalized } = useDepartment();

type UseRequestSettings = {
	url: string;
	epoqRequest: Record<string, string>;
};

export default function epoqRequestSettings(query = ""): UseRequestSettings {
	const { customerId, tenantId, sessionId } = epoqConfig();

	return {
		url: "https://search.epoq.de/inbound-servletapi/getSearchResult",
		epoqRequest: {
			customerId,
			format: "json",
			// ⚠️ attribute name has to be "e:gender" but value has to be department
			matchAttr: "e:gender",
			matchType: "filter",
			matchValue: departmentCapitalized.value,
			query,
			sessionId,
			style: "compact",
			tenantId,
		},
	};
}
